import React from 'react';
const Footer = () => {
  return (
    <section className="footer-section">
      <div className="footer-height-set">
        <div className="footer-sticky">
          <div className="container-1280">
            <div className="div-block-40">
              <div className="logo-footer">
                <div className="certification-icon-block">
                  <div className="client-img">
                    <img src="assets/images/certificates/pci3.webp" className="img-responsive" alt="Credence is PCI DSS certified" loading="lazy"/>
                  </div>
                  <div className="client-img">
                    <img src="assets/images/certificates/ISO27001.webp" className="img-responsive" alt="ISO certified" loading="lazy"/>
                  </div>
                  <div className="client-img">
                    <img src="assets/images/certificates/AICPA-SOC-2-TYPE-II-Certified.webp" className="img-responsive" alt="SOC II certified" loading="lazy"/>
                  </div>
                  <div className="client-img">
                    <img src="assets/images/certificates/better-business-bureau.webp" className="img-responsive" alt="a BBB Accredited Business" loading="lazy"/>
                  </div>
                  <div className="client-img">
                    <img src="assets/images/certificates/ACA.webp" className="img-responsive" alt="an ACA International member" loading="lazy"/>
                  </div>
                  <div className="client-img">
                    <img src="assets/images/certificates/MBE.webp" className="img-responsive" alt="a Minority-Owned Business" loading="lazy"/>
                  </div>
                </div>
              </div>
              <div className="footer-sitemap">
                <div className="footer-header">Sitemap</div>
                <div className="footer-link-block">
                  <a href="./">Home</a>
                  <a href="./About-Us">About Us</a>
                
                  <a href="./Contact-Us">Contact</a>
                </div>
              </div>
              <div className="footer-sitemap">
                            <div className="footer-header">
                            Rights & Policies
                            </div>
                            <div className="footer-link-block">
                                <a href="./Privacy-Policy">Privacy</a>
                                <a href="./Legal">Your Legal Rights</a>
                                <a href="./Refund-Policy">Refund Policy</a>
                                <a href="./Sms-Policy">SMS Policy</a>
                            </div>
                        </div>
              <div className="footer-address-block">
                <div className="footer-address">
                  <div className="footer-header">Address</div>
                  <div className="footer-address-body">
                    <span className="d-flex align-items-center mb-2">
                      <i className="bx bx-map me-2"></i>
                      <p className=" text-balance mb-0 ">
                      1111 Digital Drive, Suite 101, Richardson TX 75081
                      </p>
                    </span>
                    <span className="d-flex align-items-center mb-2">
                      <i className="bx bx-phone me-2"></i>
                      <p className="text-balance mb-0"><a href="tel:+1-855-880-4791" style={{textDecoration:"underliner"}}> +1-855-880-4791</a></p>
                    </span>
                    <span className="d-flex align-items-center mb-2">
                      <i className="bx bx-paper-plane me-2"></i>
                      <p className="text-balance mb-0"><a href="mailto:customerservice@credencerm.com" style={{textDecoration:"underliner"}}>
                                        customerservice@credencerm.com</a></p>
                    </span>
                  </div>
                </div>
                <div className="brand-logo">
                  <img src="./assets/images/credence-pay-logo.png" width="180px" alt="Credence Resource Management, LLC logo"/>
                </div>
              </div>
            </div>
            <div className="div-block-41">
            <div className="div-block-42 mb-1">
                            <p className="small-label text-balance mb-0">This communication is an attempt to collect a debt by a debt collector. Any
                                information obtained will be used for that purpose.</p>
                            <p className="small-label text-balance mb-0 text-end">We are required to inform you that we only communicate in English and Spanish. We
                                do not provide any other language access services.</p>
                        </div>
            <div className="div-block-43">
              <div className="footer-text mt-2 text-balance">
                Copyright © {new Date().getFullYear()},{" "}<strong>Credence Resource Management, LLC</strong>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
